import moment from 'moment'

export default class BosLink {
    bosLink

    constructor (bosLink) {
        this.bosLink = bosLink
    }

    static create (bosLink) {
        return new BosLink(bosLink)
    }

    getId () {
        return this.bosLink.id
    }

    getLinkHash () {
        return this.bosLink.linkHash
    }

    isActive () {
        return moment(this.bosLink.expireTime).isAfter(Date.now())
    }

    getExpireTime (format = null) {
        const expireTime = this.bosLink.expireTime
        return format
            ? moment(expireTime).format('DD.MM.YYYY HH:mm')
            : expireTime
    }
}
